import { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { MONTHS } from "../lib/store";
import { Avatar } from "./Shared";

export function useEmployees() {
  const [emps, setEmps] = useState([]);
  useEffect(() => { api.employees().then(setEmps).catch(() => {}); }, []);
  return emps;
}
export function EmployeePicker({ value, onChange, employees, includeAll = false, disabled = false, testid = "employee-picker" }) {
  return (
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled}
      className="input-c" style={{ maxWidth: 220, opacity: disabled ? 0.7 : 1 }}>
      {includeAll && <option value="all">All Employees</option>}
      {employees.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
    </select>
  );
}

export function Segmented({ options, value, onChange, testidPrefix = "seg" }) {
  return (
    <div className="inline-flex elevated rounded-lg p-1 border border-subtle gap-1">
      {options.map((o) => (
        <button key={o.v} data-testid={`${testidPrefix}-${o.v}`} onClick={() => onChange(o.v)}
          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${value === o.v ? "brand-bg text-white" : "text-secondary hover:brand-text"}`}>
          {o.n}
        </button>
      ))}
    </div>
  );
}

export function Panel({ title, action, children, testid }) {
  return (
    <div className="card-panel" data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-subtle">
          <h3 className="font-display font-semibold text-base">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}
